/**
 * Authentication / authorisation vocabulary.
 *
 * Implemented by `apps/api/src/auth` and documented in `docs/api.md` §4. Decided in
 * ADR-11 to ADR-23 and, for Microsoft Entra ID sign-in, ADR-24 to ADR-33
 * (`docs/adr/`). The backend stays the single source of truth; the frontend only
 * reflects it. There is no Prisco password anywhere in this contract.
 */
/** Stable role names, highest authority first. Roles are rows; code uses the name. */
export const ROLES = ['SUPER_ADMIN', 'ADMIN', 'BD_MEMBER', 'CLIENT'];
export function isRole(value) {
    return typeof value === 'string' && ROLES.includes(value);
}
/** Account states (ADR-26). Only `ACTIVE` users can sign in. */
export const USER_STATUSES = ['ACTIVE', 'INACTIVE'];
/**
 * What a caller may do (ADR-14). The server derives these from the role; the SPA
 * uses them only to decide what to render and never re-derives them.
 */
export const CAPABILITIES = [
    'catalogue:all',
    'projects:open-any',
    'projects:manage',
    'grants:manage',
    'users:manage',
    'admins:manage',
    'access-logs:read',
    'audit-events:read',
    'settings:manage',
];
//# sourceMappingURL=auth.js.map